import * as actionTypes from './actionType';
import { I_HotelFilter, I_HotelFilterSelected } from './interface';

const HotelFilterStore = <I_HotelFilter>{
    PriceMax: 1,
    PriceMin: 0,
    DestinationList: [],
    RoomStatusList: [],
    LevelList: [],
    FacilityList: [],
    RatingList: [],
    SubjectList: [],
    LightboxDestination: [],
};

const HotelFilterSelected = <I_HotelFilterSelected>{
    // Keyword: '',
    selectedPrices: [],
    selectedDestinationID: [],
    selectedRoomStatus: [],
    selectedRatings: [],
    selectedHotelSubjects: [],
    selectedFacilities: [],
    selectedHotelLevels: [],
    Page: 1,
    PageSize: 10,
    SortType: '', // 空字串轉成網址api後傳到後端會解讀成null
};

const Hotel = {
    HotelFilterStore,
    HotelFilterSelected,
};

export const HotelReducer = (state = Hotel, action: any) => {
    switch (action.type) {
        case actionTypes.SET_HOTEL_SUCCESS:
            return { ...state, HotelFilterStore: { ...state.HotelFilterStore, ...action.payload } };
        // return { ...state, [action.payload.filterTag]: action.payload };
        case actionTypes.SET_HOTEL_SELECTED: // 傳入 { datafilter的key : 選到的值 }
            return {
                ...state,
                HotelFilterSelected: { ...state.HotelFilterSelected, ...action.payload },
            };
        case actionTypes.SET_HOTEL_LIGHTBOXDEST:
            return { ...state, HotelFilterStore: { ...state.HotelFilterStore, ...action.payload } };
        default:
            return state;
    }
};
